import { getUser } from 'core/api';
import { useAuthorization } from 'core/context';
import { useToast } from 'core/toast';
import { IUser } from 'core/utilities';
import { useEffect, useState } from 'react';

export const useCurrentUser = () => {
    const authState = useAuthorization();
    const { setToastMessage } = useToast();

    const [ currentUser, setCurrentUser ] = useState<IUser | undefined>();

    const getCurrentUser = async () => {
        const { user } = await getUser(authState);

        if (!user) return setToastMessage('Authentication failed. Please log in again');

        setCurrentUser(user);
    };

    useEffect(() => {
        getCurrentUser();
    }, []);
  
    return { currentUser };
};
